// Utils
import makeSelectOptionsSelector from 'fc-utils/makeSelectOptionsSelector'

// Constants
import {
  PROP_FIRST,
  PROP_LAST,
} from 'fc-model-users'

// Selectors
import { users$ } from 'fc-users'

// Exports
export default makeSelectOptionsSelector(PROP_FIRST, PROP_LAST)(users$)
